import { render, staticRenderFns } from "./TermsandCondition.vue?vue&type=template&id=51cc0ec8&scoped=true"
import script from "./TermsandCondition.vue?vue&type=script&lang=js"
export * from "./TermsandCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsandCondition.vue?vue&type=style&index=0&id=51cc0ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc0ec8",
  null
  
)

export default component.exports